import {
  ProcessGraphBuilderNode,
  ProcessTaskSchemaForGraphBuilderValidation,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {ProcessFlowchartInteractiveNode} from '../ProcessFlowchartVizConstants';
import {getGraphBuilderNodeType} from './getGraphBuilderNodeType';

export default function convertProcessFlowchartInteractiveNodesToProcessGraphBuilderNodes(
  interactiveNodes: Array<ProcessFlowchartInteractiveNode>,
  flowchartSchema: ProcessTaskSchemaForGraphBuilderValidation
): Array<ProcessGraphBuilderNode> {
  return interactiveNodes.map((node) => ({
    ...node,
    nodeType: getGraphBuilderNodeType(node, flowchartSchema),
  }));
}
